module.exports = __webpack_public_path__ + "static/undraw_circles_y7s2-0c1780a48801c77daafe5dc47a577847.svg";